<table class="table" [sextant]="'refs'" [url]="currentUrl">
	<thead>
		<tr>
			<th (click)="refComponent.sort('ref')">
				{{ 'adminstat.common.referer' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('userCount')">
				{{ 'adminstat.common.userCount' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('moneyCount')">
				{{ 'adminstat.common.Money' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('paidCount')">
				{{ 'adminstat.common.paidCount' | translate }}
				<i class="fa fa-sort" aria-hidden="true"></i>
			</th>
			<th (click)="refComponent.sort('domainCount')">
				{{ 'adminstat.billing.domain_billing.totalDomainCount' | translate }}
				<span class="js-col-icon glyphicon glyphicon-sort" aria-hidden="true"></span>
			</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngFor="let ref of refs | orderBy: {property: refComponent.column, direction: refComponent.direction}; let refIndex = index"
			[class]="ref.isGroup ? (ref.ref == 'Total' ? 'table-info ' : 'table-success') : (!ref.subGroup ? 'table-warning' : null)">
			<td>
				<i *ngIf="ref.isGroup && ref.ref != 'Total' && !refComponent.itemLoader[refIndex]" [class]="ref.opened ? 'fa fa-minus' : 'fa fa-plus'" aria-hidden="true"></i>

				<span *ngIf="refs && refComponent.itemLoader[refIndex]" class="loader" style="cursor:pointer;">
					<img src="/img/loader.svg" class="img-responsive">
				</span>

				<!--Группы-->
				<span *ngIf="ref.isGroup" style="cursor:pointer;">
					<a class="js-show-ref-item-group" (click)="refComponent.showRefExpand(ref, refIndex)">{{ ref.ref }}</a>
				</span>

				<!--Внутри группы-->
				<span *ngIf="!ref.isGroup && ref.refGroup">
					<button style="padding-left:30px; cursor:pointer;" type="button" [sextant]="'ref-' + ref.refGroup" class="btn btn-link" (click)="refComponent.showRefDetails(ref, refIndex)">{{ ref.ref }}</button>
				</span>

				<!--Direct, Referral, Ungrouped-->
				<span *ngIf="!ref.isGroup && !ref.refGroup" style="cursor:pointer;">
					<a class="js-show-ref-item" (click)="refComponent.showRefDetails(ref, refIndex)">{{ ref.ref }}</a>
				</span>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.userCount}}
				</span>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.moneyCount / 100}} {{ 'adminstat.billing.billing.usd' | translate }}
				</span>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.paidCount}}
				</span>
			</td>
			<td>
				<span class="text-nowrap">
					{{ ref.domainCount}}
				</span>
			</td>
		</tr>
	</tbody>
</table>
